import { Component } from '@angular/core';

@Component({
  selector: 'vpfa-vehicle-or-offer-not-found',
  templateUrl: './vehicle-or-offer-not-found.component.html',
  styleUrls: ['./vehicle-or-offer-not-found.component.scss'],
})
export class VehicleOrOfferNotFoundComponent {}
